<div class="main" [ngClass]="{ 'bizzcalc-active': isBizzcalcRoute }">
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
</div>
